import { useMemo } from 'react';
import type { OrderSummaryData } from '../../../types';

export const useOrderSummary = (summary: OrderSummaryData) => {
  const finalTotal = useMemo(() => {
    // Sempre usar o total calculado (que pode ter desconto se há cupom)
    return summary.total ?? 0;
  }, [summary.total]);

  const totalProducts = useMemo(() => {
    return summary.products?.length ?? 0;
  }, [summary.products]);

  return {
    finalTotal,
    totalProducts,
  };
}; 